import React, { useState, useEffect } from 'react';
import * as d3 from 'd3';
import dagreD3 from 'dagre-d3';

export default props => {
  const { parent, resultObject, surveyLists, height } = props;
  const [svg, setSvg] = useState(null);
  const [g, setG] = useState(null);

  const WIDTH = (parent.current && parent.current.offsetWidth) || 0;

  useEffect(
    () => {
      if (svg) {
        const data = prepareDataForChart(resultObject);
        drawChart(svg, g, data);
      }
    },
    [svg, resultObject, surveyLists]
  );

  const prepareDataForChart = result => {
    if (!result) return null;

    const formattedResult = result
      .replaceAll('ObjectId("', '"')
      .replaceAll('ISODate("', '"')
      .replaceAll('"), ', '", ')
      .replaceAll('") ]', '" ]')
      .replaceAll('") }', '" }');
    const parseResult = JSON.parse(formattedResult);

    const states = parseResult.flowResults.map((fR, i) => {
      const questionFromSurveyList = surveyLists
        ? surveyLists.find(sL => sL.id === fR.question)
        : {};

      if (!questionFromSurveyList) {
        return {
          id: i,
          label: `- -
          id: ${fR.question}
          type: -`
        };
      }

      return {
        id: i,
        label: `${questionFromSurveyList.formattedGlobalIndex} (${
          questionFromSurveyList.globalIndex
        })
        id: ${fR.question}
        type: ${questionFromSurveyList.type}

        ${fR.answer && fR.answer.length ? `answer: ${fR.answer}` : ''}
        ${fR.answers && fR.answers.length ? `answers: ${fR.answers}` : ''}
        ${fR.answer_string ? `answer_string: ${fR.answer_string}` : ''}
        ${
          fR.flowsToVisit && fR.flowsToVisit.length
            ? `flowsToVisit: ${fR.flowsToVisit}`
            : ''
        }
        ${
          fR.visitedBranches && fR.visitedBranches.length
            ? `visitedBranches: ${fR.visitedBranches}`
            : ''
        }`
      };
    });
    states.push({
      id: parseResult.flowResults.length,
      label: 'END'
    });

    const edges = parseResult.flowResults.map((fR, i) => {
      const differenceMS = new Date(fR.finished_at) - new Date(fR.started_at);
      const differenceS = Math.floor(differenceMS / 1000);

      return {
        start: i,
        end: i + 1,
        label: `${fR.started_at} - ${fR.finished_at} (d: ${differenceS}s)`
      };
    });

    return {
      states,
      edges
    };
  };

  const drawChart = (svgRef, gRef, chartData) => {
    if (svgRef && gRef && chartData) {
      // Create a new directed graph
      const gFlow = new dagreD3.graphlib.Graph().setGraph({});

      const { states, edges } = chartData;

      // Automatically label each of the nodes
      states.forEach(state => {
        gFlow.setNode(state.id, {
          label: state.label
        });
      });

      // Set up the edges
      edges.forEach(edge => {
        if (edge) {
          gFlow.setEdge(edge.start, edge.end, {
            label: edge.label,
            style: 'stroke: #333; stroke-width: 1.5px; fill: none;'
          });
        }
      });

      // Set some general styles
      gFlow.nodes().forEach(v => {
        const node = gFlow.node(v);
        node.rx = 5;
        node.ry = 5;
      });

      const gd3Ref = d3.select(gRef);
      const svgd3Ref = d3.select(svgRef);

      // Set up zoom support
      const zoom = d3.zoom().on('zoom', () => {
        gd3Ref.attr('transform', d3.event.transform);
      });
      svgd3Ref.call(zoom);

      // Run the renderer. This is what draws the final graph.
      const render = new dagreD3.render();
      render(gd3Ref, gFlow);

      // Center the graph
      const xCenterOffset = (WIDTH - gFlow.graph().width) / 2;
      gd3Ref.attr('transform', `translate(${xCenterOffset}, 20)`);
      svgd3Ref.attr('height', gFlow.graph().height + 40);
    }
  };

  return (
    <svg
      style={{
        width: `${WIDTH}px`,
        height: `${height}px`,
        border: '1px solid #d4d4d4'
      }}
      ref={elem => {
        if (elem) {
          setSvg(elem);
        }
      }}
    >
      <g
        ref={elem => {
          if (elem) {
            setG(elem);
          }
        }}
      />
    </svg>
  );
};
